import TypeToReducer from 'type-to-reducer';
import set from 'lodash/set';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import {
  RESET_EMPLOYEE_FORM,
  GET_EMPLOYEE_BY_ID,
  MODIFY_EDITING_EMPLOYEE,
  MODIFY_CUSTOM_FIELD_EDITING_EMPLOYEE,
  EMPLOYEES_SET_FILE,
  EMPLOYEE_UPLOAD_FILE,
  EMPLOYEE_PROGRESS_FILE,
} from 'employees/constants';

export const initialState = {
  isFetchingConfig: false,
  isFetching: false,
  isSaving: false,
  editing: {},
};

export const resetForm = (state) => ({ ...initialState });

export const getByIdPending = (state) => ({ ...state, isFetching: true });

export const getByIdRejected = (state) => ({ ...state, isFetching: false });

export const getByIdFulfilled = (state, { payload }) => ({
  ...state,
  isFetching: false,
  editing: { ...payload.employee },
});

export const modifyEmployee = (state, { payload }) => ({
  ...state,
  editing: {
    ...state.editing,
    ...payload,
  },
});

export const modifyCustomField = (state, { payload }) => {
  findAndModify(state.editing._custom, payload);
  // console.log(state.editing)
  return {
    ...state,
    editing: {
      ...state.editing,
      ...payload,
    },
  };
};

export const findAndModify = (_custom, payload) => {
  const keys = Object.getOwnPropertyNames(payload);
  const key = keys[0];
  const value = payload[key];
  let banderaExiste = false;
  _custom.forEach((element) => {
    if (element.key == key) {
      element.value = value;
      banderaExiste = true;
    }
  });
  if (!banderaExiste) _custom.push({ key, value });
  return _custom;
};

export const modifyFile = (state, { payload }) => ({
  ...state,
  editing: {
    ...state.editing,
    img: payload,
  },
});

const reducers = {
  [RESET_EMPLOYEE_FORM]: resetForm,
  [GET_EMPLOYEE_BY_ID]: {
    [PENDING]: getByIdPending,
    [REJECTED]: getByIdRejected,
    [FULFILLED]: getByIdFulfilled,
  },
  [MODIFY_EDITING_EMPLOYEE]: modifyEmployee,
  [EMPLOYEES_SET_FILE]: modifyFile,

  [EMPLOYEE_UPLOAD_FILE]: {
    [PENDING]: (state) => ({
      ...state,
      isImporting: true,
      file: { ...state.editing.img, status: 'files.uploading' },
    }),
    [FULFILLED]: (state) => ({
      ...state,
      isImporting: false,
      file: { ...state.editing.img, status: 'files.uploaded' },
    }),
    [REJECTED]: (state) => ({
      ...state,
      isImporting: false,
      file: { ...state.editing.img, status: 'files.fail' },
    }),
  },
  [EMPLOYEE_PROGRESS_FILE]: (state, { payload }) => ({
    ...state,
    file: { ...state.file, percentage: payload },
  }),
  [MODIFY_CUSTOM_FIELD_EDITING_EMPLOYEE]: modifyCustomField,
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/reducers/employees_form_reducers.js